import EmailField from 'components/EmailField';
import { localizable } from 'components/Localization';
import { FooterContainer } from 'components/PanelFooter';
import 'containers/Sale/OffersSection/style.css';
import { computed, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import {
  DefaultButton,
  PrimaryButton,
} from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import React, { Component } from 'react';

@inject('app', 'user')
@localizable
@observer
class ContactPanel extends Component {
  @observable email = '';
  @observable phoneNumber = '';

  componentDidMount() {
    const { offer } = this.props;

    this.email = offer.buyer.buyer_email;
    this.phoneNumber = offer.buyer.buyer_phone;
  }

  @computed get isUnique() {
    const { offer } = this.props;
    if (offer && offer.buyer && offer.buyer.buyer_email === this.email) {
      return true;
    }
    return this.email !== '' && !this.props.usedEmails.includes(this.email);
  }

  @computed get isValid() {
    const { hasPermissions } = this.props;
    return this.isUnique && hasPermissions;
  }

  @computed get phoneNumberError() {
    const { submitError, t } = this.props;
    return submitError &&
      submitError.data.phoneNumber === this.phoneNumber &&
      submitError.error.startsWith('phone_number_')
      ? t(
          `phonenumbererror::${submitError.error.substring(
            'phone_number_'.length
          )}`
        )
      : '';
  }

  emailValidation = (_) => {
    if (this.isUnique) {
      return '';
    }
    const { t } = this.props;
    return t('Already registered');
  };

  handleSave = () => {
    const { onSave } = this.props;
    if (!onSave) return;

    onSave({ email: this.email, phoneNumber: this.phoneNumber });
  };

  handleClose = () => {
    const { onClose } = this.props;
    if (onClose) onClose();
  };

  handleChanged = (field) => (value, index, customValue) => {
    const valueKey = !!value ? value.key : undefined;
    this[field] = customValue || valueKey || value;
  };

  render() {
    const { t } = this.props;
    return (
      <Panel
        headerText={t('Update Contact')}
        type={PanelType.medium}
        isOpen={this.props.isOpen}
        onDismiss={this.handleClose}
        onRenderFooterContent={() => this.renderPanelFooterContent()}
        isFooterAtBottom={true}
        closeButtonAriaLabel="Close"
      >
        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-lg6 ms-md12 ms-sm12">
              <EmailField
                label={t('Email')}
                value={this.email}
                iconProps={{ iconName: 'Mail' }}
                required={true}
                onChanged={this.handleChanged('email')}
                validateOnLoad={false}
                onGetErrorMessage={this.emailValidation}
                componentRef={(ref) => (this.emailTextField = ref)}
                validateOnFocusOut
                autoComplete="nope"
              />
            </div>
            <div className="ms-Grid-col ms-lg6 ms-md12 ms-sm12">
              <TextField
                label={t('Phone number')}
                placeholder={t('Phone number placeholder')}
                value={this.phoneNumber}
                iconProps={{ iconName: 'Phone' }}
                onChanged={this.handleChanged('phoneNumber')}
                validateOnLoad={false}
                componentRef={(ref) => (this.phoneNumberTextField = ref)}
                errorMessage={this.phoneNumberError}
                validateOnFocusIn={true}
                validateOnFocusOut={true}
                autoComplete="nope"
                inputMode="tel"
              />
            </div>
          </div>
        </div>
      </Panel>
    );
  }

  renderPanelFooterContent = () => {
    const { t } = this.props;
    return (
      <FooterContainer>
        <PrimaryButton
          onClick={this.handleSave}
          style={{ marginRight: '8px' }}
          disabled={!this.isValid}
        >
          {t('Save')}
        </PrimaryButton>
        <DefaultButton onClick={this.handleClose}>{t('Cancel')}</DefaultButton>
      </FooterContainer>
    );
  };
}

export default ContactPanel;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/OffersSection/ContactPanel.jsx